import { fromJS } from 'immutable';

import {
  GET_CONFIGURATION_REQUEST,
  GET_CONFIGURATION_SUCCESS,
  GET_CONFIGURATION_FAILURE,
} from './types';

const initialState = fromJS({
  configuration: false,
  loading: true,
  error: false,
});

export function getConfigurationRequest() {
  return {
    type: GET_CONFIGURATION_REQUEST,
  };
}

export function getConfigurationSuccess(configuration) {
  return {
    type: GET_CONFIGURATION_SUCCESS,
    configuration,
  };
}

export function getConfigurationFailure(error) {
  return {
    type: GET_CONFIGURATION_FAILURE,
    error,
  };
}

export default function dashboardConfigurationReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CONFIGURATION_REQUEST:
      return state.set('loading', true);
    case GET_CONFIGURATION_SUCCESS:
      return state.withMutations((s) =>
        s
          .set('loading', false)
          .set('configuration', fromJS(action.configuration))
          .set('error', false),
      );
    case GET_CONFIGURATION_FAILURE:
      return state.withMutations((s) =>
        s
          .set('loading', false)
          .set('configuration', fromJS(action.configuration))
          .set('error', false),
      );
    default:
      return state;
  }
}
